<template>
  <div
    class="able-to-vote-slider"
    :class="fadeClasses"
  >
    <div class="voters-group">
      <p class="age">
        <span class="left"><countTo
          :suffix="'%'"
          :startVal="percentage"
          :endVal="newPercentage"
          :duration="1000"
          :decimals="0"
        ></countTo></span>
        <span class="right"><countTo
          :suffix="'+'"
          :startVal="age"
          :endVal="newAge"
          :duration="1000"
          :decimals="0"
        ></countTo></span>
      </p>
      <p class="percent">procent van de bevolking</p>
      <div class="wrap">
        <div class="circle">
          <img
            alt=""
            draggable="false"
            class="group-people"
            :src="require(`@/assets/images/able-to-vote/${newYear}.png`)"
          />
        </div>
      </div>
    </div>
    <div class="controls">
      <button
        class="button prev"
        @click="prev"
        :class="prevClasses"
      >
        <svg class="chevron" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 1.501l-7 7 7 7" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>
      </button>
      <span class="year">
        <countTo
          :startVal="year"
          :endVal="newYear"
          :duration="1000"
          :decimals="0"
          separator=""
        ></countTo>
      </span>
      <button
        class="button next"
        @click="next"
        :class="nextClasses"
      >
        <svg class="chevron" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 15.499l7-7-7-7" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { fadeMixin } from '@/mixins'

export default {
  name: 'AbleToVoteSlider',
  data () {
    return {
      index: 0,
      age: 23,
      newAge: 23,
      percentage: 23,
      newPercentage: 23,
      year: 1919,
      newYear: 1919,
      slides: [{
        age: 25,
        percentage: 23,
        year: 1919
      }, {
        age: 25,
        percentage: 47,
        year: 1922
      }, {
        age: 23,
        percentage: 57,
        year: 1946
      }, {
        age: 21,
        percentage: 59,
        year: 1967
      }, {
        age: 18,
        percentage: 67,
        year: 1972
      }, {
        age: 18,
        percentage: 75,
        year: 2019
      }]
    }
  },
  mixins: [fadeMixin],
  components: {
    countTo
  },
  methods: {
    next () {
      if (this.index < this.slides.length - 1) {
        this.index++
        this.slideChange()
      }
    },
    prev () {
      if (this.index > 0) {
        this.index--
        this.slideChange()
      }
    },
    slideChange () {
      // Age
      this.age = this.newAge
      this.newAge = this.slides[this.index].age

      // Year
      this.year = this.newYear
      this.newYear = this.slides[this.index].year

      // Percentage of people
      this.percentage = this.newPercentage
      this.newPercentage = this.slides[this.index].percentage
    }
  },
  computed: {
    prevClasses () {
      return {
        'disabled': this.index === 0
      }
    },
    nextClasses () {
      return {
        'disabled': (this.index === this.slides.length - 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.able-to-vote-slider {
  margin: 50px auto;

  @media (min-width: 768px) {
    margin: 100px auto;
    width: 400px;
  }
}

.voters-group {
  text-align: center;
  position: relative;
}

.wrap {
  position: relative;
}

.percent {
  text-align: left;
  font-size: 14px;
  position: relative;
  top: -7px;
}

.group-people {
  width: 290px;
  height: 243px;
  margin: -10px auto 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
  top: 50%;
  z-index: 1;
}

.age {
  @extend %clearfix;

  font-size: 32px;
  font-weight: $fw-bold;
  position: relative;
  z-index: 2;

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  @media (min-width: 768px) {
    font-size: 46px;
  }
}

.circle {
  width: 280px;
  height: 140px;
  background-color: $c-red;
  border-radius: 50%;
  margin: 50px auto;
  will-change: transform;
  transition: transform 400ms ease;

  @media (min-width: 768px) {
    margin: 0 auto;
    width: 400px;
    height: 200px;
  }
}

.voters {
  text-align: center;
  font-size: 32px;
  font-weight: $fw-bold;
  color: white;
  position: absolute;
  bottom: 18px;
  left: 0;
  right: 0;
  z-index: 2;

  @media (min-width: 768px) {
    font-size: 46px;
  }
}

.controls {
  text-align: center;
  margin-top: 10px;
  position: relative;
  z-index: 2;
}

.year {
  width: 60px;
  display: inline-block;

  @media (min-width: 768px) {
    width: 86px;
  }
}

.button {
  padding: 20px;
  background: none;
  border: none;
  cursor: pointer;
  outline: 0;

  @media (min-width: 768px) {
    padding: 29px;
  }
}

.chevron {
  width: 10px;
  height: 17px;

  @media (min-width: 768px) {
    width: 14px;
    height: 24px;
  }
}

.disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

.year {
  font-size: 24px;
  font-weight: $fw-bold;

  @media (min-width: 768px) {
    font-size: 34px;
  }
}
</style>
